/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `REQUEST` - Request
 * * `RESPOND` - Respond
 * * `CONFIRM` - Confirm
 * * `CANCEL` - Cancel
 * * `UPDATE` - Update
 */
export enum ActionEnum {
    REQUEST = 'REQUEST',
    RESPOND = 'RESPOND',
    CONFIRM = 'CONFIRM',
    CANCEL = 'CANCEL',
    UPDATE = 'UPDATE',
}
